import { Sidebar } from '@trukt/ui/Sidebar';
import { useMsal, useAccount } from '@azure/msal-react';
import packageJson from '../../../../../package.json';

import { HelpCenterButton } from './HelpCenterButton';
import { useSidebarItems } from './hooks';

export const SidebarContainer = () => {
  const sidebarItems = useSidebarItems();

  const { accounts, instance } = useMsal();
  const account = useAccount(accounts[0]);
  const claims = (account?.idTokenClaims ?? accounts[0]?.idTokenClaims) as
    { email?: string; emails?: string[]; preferred_username?: string } | undefined;
  const accountInfo = account
    ? {
        name: account.name,
        email:
          account.username ||
          account.loginHint ||
          accounts[0]?.username ||
          accounts[0]?.loginHint ||
          claims?.preferred_username ||
          claims?.email ||
          claims?.emails?.[0],
      }
    : null;

  return (
    <Sidebar
      items={sidebarItems}
      accountInfo={accountInfo}
      version={packageJson.version}
      onLogoutClick={() => instance.logoutRedirect({ account })}
      itemsSuffix={
        <div className="mt-4 mb-2 grid justify-center gap-2">
          <HelpCenterButton />
        </div>
      }
    />
  );
};
